import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'

const DEFAULT_EMPTY_VALUE = '--'
export default {
  methods: {
    showEdit (event) {
      const { id, name } = event?.data || {}
      this.$router.push({
        name: 'Partner',
        params: {
          id
        },
        query: {
          partner: name || DEFAULT_EMPTY_VALUE
        }
      }).then()
    },

    onPartnerActivation (event) {
      const { deactivated_at: deactivatedAt, id, name } = event?.data || {}
      if (!id) {
        return
      }
      const title = !deactivatedAt ? this.$t('administration/partner.partner_deactivation') : this.$t('administration/partner.partner_activation')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', !deactivatedAt ? this.$t('base.deactivate') : this.$t('base.activate'))
      this.$set(this.informationDialogConfig, 'message', !deactivatedAt ? this.$t('administration/partner.confirm_deactivation') : this.$t('administration/partner.confirm_activation'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.partnerActivation(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async partnerActivation (event) {
      try {
        const { id, deactivated_at: deactivatedAt } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.partners || {}
        await api('administration').patch(`partners/${id}/${deactivatedAt ? 'activate' : 'deactivate'}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onPartnerDelete (event) {
      const { id, name } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('administration/partner.delete')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', this.$t('base.save'))
      this.$set(this.informationDialogConfig, 'message', this.$t('administration/partner.confirm_delete'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.partnerDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async partnerDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.partners || {}

        await api('administration').delete(`partners/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
